import { createRouter, createWebHistory } from 'vue-router'
import BasicLayout from '@/layouts/BasiceLayOut.vue'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import HelloWorld from '../components/HelloWorld.vue'

const routes = [
  {
    path: '/',
    component: BasicLayout,
    meta: { requiresAuth: true, title: '首页' },
    children: [
      {
        path: '',
        name: 'Home',
        component: HomeView,
        meta: { title: '首页' }
      },
      {
        path: 'user-list',
        name: 'UserList',
        component: HelloWorld,
        meta: { title: '用户列表' }
      }
    ]
  },
  {
    path: '/login',
    component: LoginView,
    name: 'login',
    meta: { title: '登录' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const pageTitle = to.meta.title || '翼查通客户管理中心'
  document.title = pageTitle
  next()
})

export default router

